// plugins/index.js
import ThemeManager from './theme'
import registerGlobalCom from './registerGlobalCom'
import logServeCof from './logServeCof'

const plugins = [
    ThemeManager,
    registerGlobalCom,
    logServeCof
]

export default {
    install(Vue, options) {
        plugins.forEach(plugin => {
            Vue.use(plugin, options)
        })
    }
}
